module.exports = __webpack_public_path__ + "static/media/aurora.11b8f873.gif";